/* Mobile header: turns the desktop link row into a hamburger + drawer under 1080px.
   Progressive enhancement — it reads whatever links the header already renders, so
   admin menu changes flow through automatically. Load once, sitewide:
   <script src="{{ 'mw-mobile-nav.js' | asset_url }}" defer></script>  */
(function () {
  var inner = document.querySelector('.nav__inner');
  if (!inner || inner.querySelector('.nav__burger')) return;
  var links = inner.querySelector('.nav__links');
  if (!links) return;
  var header = inner.closest('header, .nav') || inner.parentNode;

  var burger = document.createElement('button');
  burger.type = 'button';
  burger.className = 'nav__burger';
  burger.setAttribute('aria-label', 'Menu');
  burger.setAttribute('aria-expanded', 'false');
  burger.innerHTML = '<span></span><span></span><span></span>';

  var right = inner.querySelector('.nav__right');
  if (right) right.appendChild(burger); else inner.appendChild(burger);

  var drawer = document.createElement('div');
  drawer.className = 'nav__drawer';
  drawer.hidden = true;
  var list = document.createElement('nav');
  list.className = 'nav__drawer-links';
  list.setAttribute('aria-label', 'Main menu');
  [].slice.call(links.querySelectorAll('a')).forEach(function (a) {
    var c = a.cloneNode(true);
    c.removeAttribute('class');
    list.appendChild(c);
  });
  drawer.appendChild(list);
  header.appendChild(drawer);

  var scrim = document.createElement('div');
  scrim.className = 'nav__scrim';
  scrim.hidden = true;
  header.appendChild(scrim);

  function setOpen(open) {
    burger.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    drawer.hidden = false;
    scrim.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.toggle('is-open', open);
      scrim.classList.toggle('is-open', open);
    });
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (!open) {
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) { drawer.hidden = true; scrim.hidden = true; }
      }, 300);
    }
  }

  burger.addEventListener('click', function () { setOpen(!burger.classList.contains('is-open')); });
  scrim.addEventListener('click', function () { setOpen(false); });
  list.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1080 && burger.classList.contains('is-open')) setOpen(false);
  });
}());
